/**
 * Crea el botón de jugar apuesta
 * @param {*} scene
 */
export function crearBotonJugar(scene) {
  scene.botonJugar = scene.add.image(898, 418, "botonJugar").setInteractive();

  scene.botonJugar.on("pointerover", () => {
    if (!scene.noVaMas) {
      scene.botonJugar.setTexture("botonJugarHover");
    }
  });

  scene.botonJugar.on("pointerout", () => {
    if (!scene.noVaMas) {
      scene.botonJugar.setTexture("botonJugar");
    }
  });

  scene.botonJugar.on("pointerdown", () => {
    if (!scene.noVaMas) {
      scene.botonJugar.setTexture("botonJugarPressed");
    }
  });

  scene.botonJugar.on("pointerup", () => {
    if (!scene.noVaMas) {
      if (scene.botonJugar.input?.isOver) {
        scene.botonJugar.setTexture("botonJugar");
      } else {
        scene.botonJugar.setTexture("botonJugarHover");
        scene.jugarApuesta();
      }
    }
  });
}
